// extracted by mini-css-extract-plugin
export default {"current":"bs_gC","update":"bs_gD","showColors":"bs_gF","positive":"bs_gz","negative":"bs_gB"};